/** @jsxImportSource @emotion/react */
"use client";

import type { Interpolation } from "@emotion/react";
import { Link } from "@i18n/next";
import { ArrowLeftIcon, ArrowRightIcon, Button, spacing } from "@packages/ui";
import { addDays, format, isSameDay, subDays } from "date-fns";

const containerStyle: Interpolation = {
  alignItems: "center",
  display: "flex",
  flexDirection: "row",
  flexWrap: "nowrap",
  justifyContent: "space-between",
  marginBottom: spacing.xxl,
};
type DailyReadingsNavButtonsProps = {
  currentDate: Date;
  minDate: Date;
  maxDate: Date;
};

export const DailyReadingsNavButtons = ({
  currentDate,
  minDate,
  maxDate,
}: DailyReadingsNavButtonsProps) => {
  const previous = subDays(currentDate, 1);
  const next = addDays(currentDate, 1);

  return (
    <div css={containerStyle}>
      {isSameDay(currentDate, minDate) ? (
        <div />
      ) : (
        <Button
          size={"m"}
          variant={"neutral"}
          startIcon={<ArrowLeftIcon />}
          asChild
        >
          <Link
            href={`/bible/daily-readings/${format(previous, "yyyy-MM-dd")}`}
          >
            {format(previous, "MMMM d")}
          </Link>
        </Button>
      )}
      {isSameDay(currentDate, maxDate) ? (
        <div />
      ) : (
        <Button
          size={"m"}
          variant={"neutral"}
          endIcon={<ArrowRightIcon />}
          asChild
        >
          <Link href={`/bible/daily-readings/${format(next, "yyyy-MM-dd")}`}>
            {format(next, "MMMM d")}
          </Link>
        </Button>
      )}
    </div>
  );
};
